// extracted by mini-css-extract-plugin
export default {"horizontalStyle":"RadioGroupWidget_horizontalStyle__aFEpP","verticalStyle":"RadioGroupWidget_verticalStyle__5r+yd","errorText":"RadioGroupWidget_errorText__8VPI0"};